import { render, staticRenderFns } from "./FoodKinds.vue?vue&type=template&id=ffd7d63a&"
import script from "./FoodKinds.vue?vue&type=script&lang=js&"
export * from "./FoodKinds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports